import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-6 flex flex-col w-full",
  "data-testid": "test-cancel-tour"
}
const _hoisted_2 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppModal = _resolveComponent("AppModal")!

  return (_openBlock(), _createBlock(_component_AppModal, {
    id: "parallel-edit-modal",
    visible: _ctx.isErrorModalVisible('parallelEditError'),
    modalType: "accept",
    cancelText: "tour.accept",
    onHideModal: _ctx.close
  }, {
    default: _withCtx(() => [
      (_ctx.isErrorModalVisible('parallelEditError'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("error_parallel_edits")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onHideModal"]))
}